export enum MonthlySelect {
    DateSelected = 1,
    WeekAndDaySelected = 2,
}